import 'promise-polyfill/src/polyfill';
import languageBundle from '@kirschbaum-development/laravel-translations-loader/php?namespace=translation&parameters={{$1}}!@kirschbaum-development/laravel-translations-loader';
import i18next from 'i18next';

i18next.init({
    resources: languageBundle,
    lng: window.appLocale,
});

window.i18next = i18next;
